export default __webpack_public_path__ + "c414e5d40c95b793ca3e177d0bf8ae8c.jpg";